const withLeadingZero = (number: number | string) => {
  const asString = `${number}`
  if (asString.length < 2) return `0${number}`
  return number
}

export default withLeadingZero
